import React from 'react';
import { AntButton } from 'controls/react/ant/antButton';
import { AntPopover, usePopoverManually } from 'controls/react/ant/antPopover';
import { FieldProps } from './types';
import { observer } from 'mobx-react';
import { FormBuilderContext } from '../formBuilderContext';
import { apiFetch } from 'framework/api';

const i18n = require('core/localization/localization').translator();

export const CEAction = observer(({ property }: FieldProps) => {
	const store = React.useContext(FormBuilderContext);
	const { actionType, caption, url } = property;

	const [loading, setLoading] = React.useState(false);

	const { opened, open, label } = usePopoverManually({ timeout: 2000 });

	const onClick = React.useCallback(() => {
		if (loading) return;

		setLoading(true);
		try {
			fetch(url)
				.then((response) => {
					if (response.status == 200) {
						open(i18n('Success'));
					} else {
						open('An error happened');
					}
				})
				.catch(() => {
					open('An error happened');
				})
				.finally(() => {
					setLoading(false);
				});
		} catch {}
	}, [url, loading]);

	const onLinkClick = React.useCallback(
		async (e: any) => {
			if (property.url) {
				return;
			}
			e.preventDefault();
			setLoading(true);
			const result = await apiFetch(store.getPropertyData(property));
			if (result.success) {
				const loadedUrl = result.data;
				window.open(loadedUrl, '_blank');
			}
			setLoading(false);
		},
		[property],
	);

	return (
		<div>
			<AntPopover open={opened} content={label} overlayPadding={true}>
				{actionType == 'BUTTON' && (
					<AntButton type={'primary'} onClick={onClick} loading={loading}>
						{caption}
					</AntButton>
				)}
				{actionType == 'LINK' && (
					<a href={url} onClick={onLinkClick} target={'_blank'}>
						{caption}
					</a>
				)}
				{actionType == 'LABEL' && <span>{caption}</span>}
			</AntPopover>
		</div>
	);
});
